import { render, staticRenderFns } from "./PrivateImage.vue?vue&type=template&id=b9a5860a"
import script from "./PrivateImage.vue?vue&type=script&lang=js"
export * from "./PrivateImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports